export const TCPNavigationStatuses = {
  tcpCreate: 'inactive',
  daily: 'inactive',
  weekly:'inactive',
  completed: 'inactive',
  done: 'inactive',
};
